// PACKAGES
import Cookies from 'js-cookie/src/js.cookie'

// Consent cookie is written by the career site (social-recruiting-applicant-ui) as
// `cookie_consent_{clientId}` with the value `v1|<ISO timestamp>|n:1,a:0|1,m:0|1`.
const COOKIE_PREFIX = 'cookie_consent'
const COOKIE_VERSION = 'v1'
const EXPIRY_MS = 365 * 24 * 60 * 60 * 1000

const cookieName = clientId => clientId ? `${COOKIE_PREFIX}_${clientId}` : COOKIE_PREFIX

export const getConsent = (clientId) => {
  try {
    const raw = Cookies.get(cookieName(clientId))
    if (!raw) return null

    const [version, timestamp, cats] = raw.split('|')
    if (version !== COOKIE_VERSION || !timestamp || !cats) return null
    if (Date.now() - new Date(timestamp).getTime() > EXPIRY_MS) return null

    const categories = {}
    cats.split(',').forEach(pair => {
      const [key, val] = pair.split(':')
      categories[key] = val === '1'
    })

    return { version, timestamp, categories }
  } catch (e) {
    return null
  }
}

/**
 * @function isTrackingAllowed
 * @description Tracking is allowed when the applicant has not made a consent decision
 * (legacy behaviour) or has explicitly accepted analytics cookies.
 */
export const isTrackingAllowed = (clientId) => {
  const consent = getConsent(clientId)
  return consent === null || consent.categories.a === true
}
